var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import LoginConfigURL from "@adapters/infrastructures/urlConfig/SalesJourney/Login/LoginConfigURL";
import { loginFeatureMapper } from "@domains/salesFeatures/Login/mapper/loginFeature";
import { generateHashForHmacSHA256, generateRandomString, genericEncrypt, } from "@domains/utils/encryption";
import { ssoLoginMapper } from "@domains/salesFeatures/Login/mapper/ssoLoginMapper";
var LoginRepository = /** @class */ (function () {
    function LoginRepository(http) {
        this.http = http;
    }
    LoginRepository.prototype.resendOTP = function (_a) {
        var verificationkey = _a.verificationkey, restPayload = __rest(_a, ["verificationkey"]);
        return __awaiter(this, void 0, void 0, function () {
            var url, header, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(LoginConfigURL.resendOTP);
                        header = new Headers();
                        header.append("verificationkey", verificationkey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: restPayload,
                                headers: header,
                            })];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.forgotLoginId = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.forgotLogin);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        if (data !== null && data !== undefined && (data === null || data === void 0 ? void 0 : data.data)) {
                            return [2 /*return*/, data.data];
                        }
                        else {
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginRepository.prototype.redirectionToFPDUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.FRDRedirectionURL);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    LoginRepository.prototype.logoutUser = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(LoginConfigURL.logout);
                        url.searchParams.append("flgLogoutAllD", (_a = req === null || req === void 0 ? void 0 : req.flgLogoutAllD) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: null,
                            })];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.validateChangePassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.validateChangePassword);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.validateForgotPassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.validateForgotPassword);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.userUnblock = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.userUnblock);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.userUnblockCheck = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.userUnblockCheck);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.changePassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.changePassword);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.resetPassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.resetPassword);
                        if (req.isForgotPassword) {
                            url = new URL(LoginConfigURL.ForgotResetPassword);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.reqBody,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.forgotPassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.forgotPassword);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LoginRepository.prototype.getLoginData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, loginData, loginEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(LoginConfigURL.authroizationToken);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: {
                                    authToken: req.authToken,
                                },
                            })];
                    case 1:
                        loginData = _b.sent();
                        loginEntity = {
                            cipToken: "",
                        };
                        if (typeof loginData === "object") {
                            loginEntity.cipToken = (_a = loginData === null || loginData === void 0 ? void 0 : loginData.data) === null || _a === void 0 ? void 0 : _a.jwtToken;
                        }
                        return [2 /*return*/, loginEntity];
                }
            });
        });
    };
    LoginRepository.prototype.getNewLogin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, reqId, loginData, hashStr, newReq, encryptedString, headers, hashStr, newReq, encryptedString, headers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqId = "";
                        if (!(req === null || req === void 0 ? void 0 : req.isMobile)) return [3 /*break*/, 2];
                        url = new URL(LoginConfigURL.newLoginEncrypted);
                        reqId = generateRandomString();
                        hashStr = generateHashForHmacSHA256(reqId, req.userName + req.userKey);
                        newReq = {
                            loginFor: req.loginFor,
                            hashStr: hashStr,
                            userKey: req.userKey,
                            userName: req.userName,
                        };
                        encryptedString = genericEncrypt(process.env.AES_KEY, process.env.AES_IV, JSON.stringify(newReq), 32);
                        headers = new Headers();
                        headers.append("requestid", reqId);
                        headers.append("loginvia", req.loginVia);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { loginToken: encryptedString },
                                headers: headers,
                            })];
                    case 1:
                        loginData = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        url = new URL(LoginConfigURL.newLogin);
                        reqId = generateRandomString();
                        hashStr = generateHashForHmacSHA256(reqId, req.userName + req.userKey);
                        newReq = {
                            loginFor: req.loginFor,
                            hashStr: hashStr,
                            userKey: req.userKey,
                            userName: req.userName,
                        };
                        encryptedString = genericEncrypt(process.env.AES_KEY, process.env.AES_IV, JSON.stringify(newReq), 32);
                        headers = new Headers();
                        headers.append("requestid", reqId);
                        headers.append("verificationkey", req.verificationkey);
                        headers.append("agentid", req.agentId);
                        headers.append("loginvia", req.loginVia);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { loginToken: encryptedString },
                                headers: headers,
                            })];
                    case 3:
                        loginData = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, loginFeatureMapper(loginData, reqId)];
                }
            });
        });
    };
    LoginRepository.prototype.getValidateOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, reqId, loginData, hashStr, newReq, encryptedString, headers, hashStr, newReq, encryptedString, headers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqId = "";
                        if (!(req === null || req === void 0 ? void 0 : req.isMobile)) return [3 /*break*/, 2];
                        url = new URL(LoginConfigURL.validateOTPEncrypted);
                        reqId = generateRandomString();
                        hashStr = generateHashForHmacSHA256(reqId, req.otptxt + req.tokenid);
                        newReq = {
                            empType: req.loginFor,
                            hashStr: hashStr,
                            otptxt: req.otptxt,
                            tokenid: req.tokenid,
                            userName: req.userName,
                        };
                        encryptedString = genericEncrypt(process.env.AES_KEY, process.env.AES_IV, JSON.stringify(newReq), 32);
                        headers = new Headers();
                        headers.append("requestid", reqId);
                        headers.append("loginvia", req.loginVia);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { loginToken: encryptedString },
                                headers: headers,
                            })];
                    case 1:
                        loginData = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        url = new URL(LoginConfigURL.validateOTP);
                        reqId = generateRandomString();
                        hashStr = generateHashForHmacSHA256(reqId, req.otptxt + req.tokenid);
                        newReq = {
                            empType: req.loginFor,
                            hashStr: hashStr,
                            otptxt: req.otptxt,
                            tokenid: req.tokenid,
                            userName: req.userName,
                        };
                        encryptedString = genericEncrypt(process.env.AES_KEY, process.env.AES_IV, JSON.stringify(newReq), 32);
                        headers = new Headers();
                        headers.append("requestid", reqId);
                        headers.append("loginvia", req.loginVia);
                        headers.append("verificationkey", req.verificationkey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { loginToken: encryptedString },
                                headers: headers,
                            })];
                    case 3:
                        loginData = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, loginFeatureMapper(loginData, reqId)];
                }
            });
        });
    };
    LoginRepository.prototype.validateSingleSignOn = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, newReq, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.validateSingleSignOnURL);
                        newReq = {
                            method: "POST",
                            url: url.toString(),
                            body: req,
                            skipAuthHeader: true,
                        };
                        return [4 /*yield*/, this.http.makeApiCall(newReq)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LoginRepository.prototype.validateForgotLoginId = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.validateForgotLogin);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    LoginRepository.prototype.getGuidToken = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.guidToken);
                        if (req === null || req === void 0 ? void 0 : req.strapp)
                            url.searchParams.append("strapp", req.strapp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LoginRepository.prototype.getSSOLoginData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginConfigURL.validateSingleSignOnURL);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, ssoLoginMapper(result)];
                }
            });
        });
    };
    return LoginRepository;
}());
export default LoginRepository;
